import { toast } from 'sonner';
import i18next from 'i18next';
import { useTenantStore } from '@/store/tenant.store.js';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class CommunicationChannelIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchCapabilities() {
        if (!useTenantStore.getState().selectedTenantId) return { success: false, data: [] };
        try {
            return await this.service.getAll();
        } catch (error) {
            return { success: false, data: [], error: getIntegrationErrorMessage(error) };
        }
    }

    async updatePolicy(channel, isEnabled) {
        try {
            const result = await this.service.updatePolicy(channel, isEnabled);
            toast.success(i18next.t('communicationProvider:messages.channelPolicyUpdated', {
                defaultValue: 'Channel policy updated',
            }));
            return result;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
